import React, {useState} from 'react';

import {useAppSelector} from 'stores/redux_store';

import OverlayTrigger from 'components/overlay_trigger';
import Tooltip from 'components/tooltip';
import {isCustomStatusEnabled} from 'selectors/views/custom_status';
import Constants from 'utils/constants';

interface ComponentProps {
    tooltipDirection?: 'top' | 'right' | 'bottom' | 'left';
    text?: string;
    className?: string;
}

const CustomStatusText = (props: ComponentProps) => {
    const {
        tooltipDirection = 'bottom',
        text = '',
        className = '',
    } = props;

    const customStatusEnabled = useAppSelector(isCustomStatusEnabled);
    const [show, setShow] = useState<boolean>(false);
    let spanElement: HTMLSpanElement | null = null;

    if (!customStatusEnabled) {
        return null;
    }

    const showTooltip = () => {
        if (spanElement === null) {
            return;
        }
        setShow(Boolean(spanElement && spanElement.offsetWidth < spanElement.scrollWidth));
    };

    const customStatusTextComponent = (
        <span
            className={`overflow--ellipsis text-nowrap ${className}`}
            ref={(element) => {
                spanElement = element;
                showTooltip();
            }}
        >
            {text}
        </span>
    );

    if (!show) {
        return customStatusTextComponent;
    }

    return (
        <OverlayTrigger
            delayShow={Constants.OVERLAY_TIME_DELAY}
            placement={tooltipDirection}
            overlay={
                <Tooltip id='custom-status-tooltip'>
                    {text}
                </Tooltip>
            }
        >
            {customStatusTextComponent}
        </OverlayTrigger>
    );
};

export default CustomStatusText;
